/* 
  START: you can define custom functions within this area
  v v v v v v v v v v v v v v v v v v v v v v v v v v v
*/


function bindCookiePrefsClick() {
    var cookielink = document.querySelector('a[href="#CookiePreferences"]');
    if (cookielink) {
        cookielink.addEventListener('click', openCookiePrefs, false);
    }
}
function openCookiePrefs(e) {
    e.preventDefault();
    if (typeof OneTrust !== "undefined" && typeof OneTrust.ToggleInfoDisplay === "function") {
        OneTrust.ToggleInfoDisplay();
    } else {
        console.warn('OneTrust is not loaded yet.');
    }
    return false;
}

// Pass consent selections from OneTrust to Shopify
function listenForConsentUpdates() {
  window.addEventListener("OneTrustGroupsUpdated", otEvent => {
    var shopifyConsentGroups = {
      "analytics": otEvent.detail.includes('C0002'),
      "preferences": otEvent.detail.includes('C0003'),
      "marketing": otEvent.detail.includes('C0004'),
      "sale_of_data": otEvent.detail.includes('C0004')
    };
    window.Shopify.customerPrivacy.setTrackingConsent(shopifyConsentGroups, () => {
      var updatedConsent = window.Shopify.customerPrivacy.currentVisitorConsent(); 
      window.console.log('~~~~updated Shopify Consent', updatedConsent);
    });    
  });
}

/* PLP sticky filter bar */
function initPLPStickyNav() {
  var collectionNavBar = $('.navigation--root[data-sticky="true"]');
  let plpNavTop = collectionNavBar.offset().top;
  
  function plpstickynavbar() {
    var annHeight = document.documentElement.style.getPropertyValue('--announcement-height').replace('px', '');
    var hdrHeight = document.documentElement.style.getPropertyValue('--header-height').replace('px', '');
    var scrollTrigger = (window.scrollY + parseInt(annHeight) + parseInt(hdrHeight));
    
    var collectionNavBar = $('.navigation--root[data-sticky="true"]');
    var persistentBanner = $('.persistent-banner');

    if (scrollTrigger >= plpNavTop) {
      collectionNavBar.addClass('is-stuck');
      persistentBanner.addClass('hide-persistent');
    } else {
      collectionNavBar.removeClass('is-stuck');
      persistentBanner.removeClass('hide-persistent');
    }
  }
  plpstickynavbar();
  window.addEventListener('scroll', plpstickynavbar);
}
/* END: PLP sticky filter bar */

function accessibilityFixes() {
  $('body').on('keydown', 'a, [role="button"]', function(e) {
      if (e.key === ' ') {
        e.preventDefault(); // Prevent default spacebar behavior (scrolling)
        $(this).trigger('click'); // Trigger the button's click event
      }
  });
}

/* set up custom ElevarDataLayer events */
function bindCustomElevarEvents() {

  /** 
   * Optimove in GTM needs a "cart_empty" event
   * sent only when the cart goes from 1 or more to Zero
  */
  window.on('theme:cart:quantityUpdated', ({ detail: data }) => {
    if (data.items_removed && data.items_removed.length) {
      if (data.item_count == 0) {
        window.ElevarDataLayer.push({ event: "cart_empty" });
      }
    }
  });
}

function initFooterSelectorA11yFix() {
  var link = document.querySelector('#md-footer-selector__country-popup a');
  if (link) {
    link.setAttribute('role', 'button');
    link.setAttribute('tabindex', '0');
  }
}

/* 
  ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
  END: area to define custom functions
  =====================================================
*/

/* 
  jQueryIsReady is just like like $(document).ready() - put your jQuery code here to avoid timing errors
*/
var jQueryIsReady = function() {
  /* 
    START: add any jQuery code or call functions that DEPEND on jQuery within this block
    (don't define functions here, just call them from here)
    v v v v v v v v v v v v v v v v v v v v v v v v v v v
  */
  
  accessibilityFixes();

  if ( $('.navigation--root[data-sticky="true"]').length ) {
     initPLPStickyNav();
  }
  
  /* 
    ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
    END: code that DEPENDS on jQuery goes in the area above
  */
} 
// end jQueryIsReady
// ========================================================================


/* 
  dkCustomInit is a function that runs immediately on page load, 
  but may finish before jQuery is fully loaded
*/
function dkCustomInit() {
  var checkJquery = function(){
    if (typeof jQuery === "undefined"){
        return false;
    } else {
        clearTimeout(jqInterval);
        jQueryIsReady();
    }
  }
  var jqInterval = setInterval(checkJquery,1000);

  /* 
    START: call any functions that DON'T depend on jQuery within this block
    (don't define functions here, just call them from here)
    v v v v v v v v v v v v v v v v v v v v v v v v v v v
  */

  
  // Pass consent selections from OneTrust to Shopify
  listenForConsentUpdates();

  bindCookiePrefsClick();  
  bindCustomElevarEvents();
 
  // Footer selector a11y fix
  initFooterSelectorA11yFix();
  
  /* 
    ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ ^ 
    END: functions that DON'T depend on jQuery
    =====================================================
  */ 
}
// end dkCustomInit
// ========================================================================


/* LEAVE THIS AT THE BOTTOM OF THE FILE AND DO NOT EDIT */
if (/complete|interactive|loaded/.test(document.readyState)) {
    dkCustomInit();
} else {
    document.addEventListener('DOMContentLoaded', dkCustomInit);
}
